import { gql } from '@apollo/client';


export const LEADS_INPUT = gql`
mutation InsertLeads($leads: [leadTypeInput]!) {
    insertLeads(leads: $leads) {
    status
    message
  }
}
`;

export const LEADS_FILTERS = gql`
  query GetLeadFilters(
    $filters: leadfiltersInput!,
    $isPipeline: Boolean!
    $leadScope: LeadScope!
    $assignedTo: String
  ) {
    getLeadFilters(
      filters: $filters,
      isPipeline: $isPipeline
      leadScope: $leadScope,
      assignedTo: $assignedTo
    ) {
      responsestatus
      message
      agencyName
      state
      city
      channel
      assignedTo
      timeZone
      followup
      stage
      status
      callscheduledwithOPs
      successfull
      priority
      contactEmail
    }
  }
`;

export const GET_ALL_LEADS = gql`
  query GetAllLeads(
    $page: Int!,
    $pageSize: Int!,
    $filters: leadfiltersInput!,
    $sort: leadfiltersInput!,
    $isPipeline: Boolean!,
    $leadScope: LeadScope!,
    $assignedTo: String,
    $loginUserId: String
  ) {
    getAllLeads(
      page: $page,
      pageSize: $pageSize,
      filters: $filters,
      sort: $sort,
      isPipeline: $isPipeline
      leadScope: $leadScope,
      assignedTo: $assignedTo,
      loginUserId: $loginUserId
    ) {
      status
      message
      count
      response {
        id
        leadID
        isInPipeline
        pipelineStage
        lostReason
        dealValue
        createdDate
        createdBy
        lastUpdatedDate
        lastContactedDate
        followup
        followupDate
        callscheduledwithOPs
        assign
        assignedTo
        assignTo
        assignedAt
        isAssignLocked
        assignLockedAt
        assignUnlockAt
        priority
        status
        stage
        channel
        successfull
        agencyName
        dba
        address
        mailingAddress
        city
        state
        timeZone
        webURL
        contactInfoURL
        linkedinURL
        contactInfoComments
        callingComments
        emailComments
        linkedinComments
        scheduledCallComments
        opsTeamComments
        leadsContacts {
          contactPerson
          title
          phone
          email
          optIn
          remarks
          status
        }
        leadsCalls {
          date
          time
          status
          spokeWith
          callby
          emailSent
          remarks
        }
        leadsEmails {
          date
          time
          status
          emailedto
          emailedy
          remarks
          emailFollowup
          emailFrom
          emailBody
          emailID
          conversationId
          trackId
          deliveryStatus
          openedAt
          replyMessageIds
          replyFrom
          replySubject
          replyReceivedAt
          replyBody
        }
        leadsLinkedins {
          date
          time
          status
          requestTo
          requestBy
          remarks
        }
        leadsScheduledCalls {
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          timeZone
          remarks
        }
        leadsOPS {
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          remarks
          callConnected
          clientAttendees
          blueplanitAttendees
          amsusedbyClient
          clientRequirements
          pros
          cons
          emailSent
        }
      }
    }
  }
`;
export const UPDATE_LEAD = gql`
  mutation (
    $id: String!, 
    $createdDate: String,
    $createdBy: String,
    $lastUpdatedDate: String,
    $lastContactedDate: String,
    $followup: Boolean,
    $followupDate: String,
    $callscheduledwithOPs: Boolean,
    $assign: Boolean,
    $assignedTo: String,
    $assignTo: String,
    $assignedAt: String,
    $isAssignLocked: Boolean,
    $assignLockedAt: String,
    $assignUnlockAt: String,
    $priority: String,
    $status: String,
    $stage: String,
    $channel: String,
    $successfull: Boolean,
    $agencyName: String,
    $dba: String,
    $address: String,
    $mailingAddress: String,
    $city: String,
    $state: String,
    $timeZone: String,
    $webURL: String,
    $contactInfoURL: String,
    $linkedinURL: String,
    $contactInfoComments: String,
    $callingComments: String,
    $emailComments: String,
    $linkedinComments: String,
    $scheduledCallComments: String,
    $opsTeamComments: String,
    $leadsContacts: [LeadsContactsInput],
    $leadsCalls: [LeadsCallsInput],
    $leadsEmails: [LeadsEmailsInput],
    $leadsLinkedins: [LeadsLinkedinsInput],
    $leadsScheduledCalls: [LeadsScheduledCallsInput],
    $leadsOPS: [LeadsOPSInput],
    $isInPipeline: Boolean,
    $pipelineStage: String,
    $lostReason: String,
    $dealValue: String
    ) {
    updateLead(
      id: $id,
      createdDate:  $createdDate,
      createdBy:  $createdBy,
      lastUpdatedDate:  $lastUpdatedDate,
      lastContactedDate:  $lastContactedDate,
      followup:  $followup,
      followupDate:  $followupDate,
      callscheduledwithOPs:  $callscheduledwithOPs,
      assign:  $assign,
      assignedTo:  $assignedTo,
      assignTo:  $assignTo,
      assignedAt: $assignedAt,
      isAssignLocked: $isAssignLocked,
      assignLockedAt: $assignLockedAt,
      assignUnlockAt: $assignUnlockAt,
      priority:  $priority,
      status:  $status,
      stage:  $stage,
      channel:  $channel,
      successfull:  $successfull,
      agencyName:  $agencyName,
      dba:  $dba,
      address:  $address,
      mailingAddress:  $mailingAddress,
      city:  $city,
      state:  $state,
      timeZone:  $timeZone,
      webURL:  $webURL,
      contactInfoURL:  $contactInfoURL,
      linkedinURL:  $linkedinURL,
      contactInfoComments:  $contactInfoComments,
      callingComments:  $callingComments,
      emailComments:  $emailComments,
      linkedinComments:  $linkedinComments,
      scheduledCallComments:  $scheduledCallComments,
      opsTeamComments:  $opsTeamComments,
      leadsContacts:  $leadsContacts,
      leadsCalls:  $leadsCalls,
      leadsEmails:  $leadsEmails,
      leadsLinkedins:  $leadsLinkedins,
      leadsScheduledCalls:  $leadsScheduledCalls,
      leadsOPS:  $leadsOPS,
      isInPipeline: $isInPipeline,
      pipelineStage: $pipelineStage,
      lostReason: $lostReason,
      dealValue: $dealValue
      ) {
        id
        leadID
        isInPipeline
        pipelineStage
        lostReason
        dealValue
        createdDate
        createdBy
        lastUpdatedDate
        lastContactedDate
        followup
        followupDate
        callscheduledwithOPs
        assign
        assignedTo
        assignTo
        assignedAt
        isAssignLocked
        assignLockedAt
        assignUnlockAt
        priority
        status
        stage
        channel
        successfull
        agencyName
        dba
        address
        mailingAddress
        city
        state
        timeZone
        webURL
        contactInfoURL
        linkedinURL
        contactInfoComments
        callingComments
        emailComments
        linkedinComments
        scheduledCallComments
        opsTeamComments
        leadsContacts{
          contactPerson
          title
          phone
          optIn
          email
          remarks
          status
          verifiedAt
          verifyResult
          verifyCode
          verifyReason
          unsubscribedAt
        }
        leadsCalls{
          date
          time
          status
          spokeWith
          callby
          emailSent
          remarks
          recordingid
          from
          to
          duration
        }
        leadsEmails{
          id
          date
          time
          status
          emailedto
          emailedy
          remarks
          emailFollowup
          emailFrom
          emailBody
          emailID
          conversationId
          trackId
          deliveryStatus
          openedAt
          deliveredAt
          bounceReason
          replyMessageIds
          replyFrom
          replySubject
          replyReceivedAt
          replyBody
          body
          isDraft
          draftSavedAt
        }
        leadsLinkedins{
          date
          time
          status
          requestTo
          requestBy
          remarks
        }
        leadsScheduledCalls{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          timeZone
          remarks
        }
        leadsOPS{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          remarks
          callConnected
          clientAttendees
          blueplanitAttendees
          amsusedbyClient
          clientRequirements
          pros
          cons
          emailSent
        }
        newHistoryEntry {
          id
          leadId
          userName
          action
          leadStatus
          changeTime
          actorType
          summary
          changes { field oldValue newValue section kind item }
        }

    }
  }
`;

export const CREATE_LEAD = gql`
  mutation (
    $createdDate: String,
    $createdBy: String,
    $lastUpdatedDate: String,
    $lastContactedDate: String,
    $followup: Boolean,
    $followupDate: String,
    $callscheduledwithOPs: Boolean,
    $assign: Boolean,
    $assignedTo: String,
    $assignTo: String,
    $assignedAt: String,
    $isAssignLocked: Boolean,
    $assignLockedAt: String,
    $assignUnlockAt: String,
    $priority: String,
    $status: String,
    $stage: String,
    $channel: String,
    $successfull: Boolean,
    $agencyName: String,
    $dba: String,
    $address: String,
    $mailingAddress: String,
    $city: String,
    $state: String,
    $timeZone: String,
    $webURL: String,
    $contactInfoURL: String,
    $linkedinURL: String,
    $contactInfoComments: String,
    $callingComments: String,
    $emailComments: String,
    $linkedinComments: String,
    $scheduledCallComments: String,
    $opsTeamComments: String,
    $leadsContacts: [LeadsContactsInput],
    $leadsCalls: [LeadsCallsInput],
    $leadsEmails: [LeadsEmailsInput],
    $leadsLinkedins: [LeadsLinkedinsInput],
    $leadsScheduledCalls: [LeadsScheduledCallsInput],
    $leadsOPS: [LeadsOPSInput],
    $isInPipeline: Boolean,
    $pipelineStage: String,
    $lostReason: String,
    $dealValue: String
    ) {
      createLead(
        createdDate:  $createdDate,
        createdBy:  $createdBy,
        lastUpdatedDate:  $lastUpdatedDate,
        lastContactedDate:  $lastContactedDate,
        followup:  $followup,
        followupDate:  $followupDate,
        callscheduledwithOPs:  $callscheduledwithOPs,
        assign:  $assign,
        assignedTo:  $assignedTo,
        assignTo:  $assignTo,
        assignedAt: $assignedAt,
        isAssignLocked: $isAssignLocked,
        assignLockedAt: $assignLockedAt,
        assignUnlockAt: $assignUnlockAt,
        priority:  $priority,
        status:  $status,
        stage:  $stage,
        channel:  $channel,
        successfull:  $successfull,
        agencyName:  $agencyName,
        dba:  $dba,
        address:  $address,
        mailingAddress:  $mailingAddress,
        city:  $city,
        state:  $state,
        timeZone:  $timeZone,
        webURL:  $webURL,
        contactInfoURL:  $contactInfoURL,
        linkedinURL:  $linkedinURL,
        contactInfoComments:  $contactInfoComments,
        callingComments:  $callingComments,
        emailComments:  $emailComments,
        linkedinComments:  $linkedinComments,
        scheduledCallComments:  $scheduledCallComments,
        opsTeamComments:  $opsTeamComments,
        leadsContacts:  $leadsContacts,
        leadsCalls:  $leadsCalls,
        leadsEmails:  $leadsEmails,
        leadsLinkedins:  $leadsLinkedins,
        leadsScheduledCalls:  $leadsScheduledCalls,
        leadsOPS:  $leadsOPS,
        isInPipeline: $isInPipeline,
        pipelineStage: $pipelineStage,
        lostReason: $lostReason,
        dealValue: $dealValue
      ) {
        id
        leadID
        isInPipeline
        pipelineStage
        lostReason
        dealValue
        createdDate
        createdBy
        lastUpdatedDate
        lastContactedDate
        followup
        followupDate
        callscheduledwithOPs
        assign
        assignedTo
        assignTo
        assignedAt
        isAssignLocked
        assignLockedAt
        assignUnlockAt
        priority
        status
        stage
        channel
        successfull
        agencyName
        dba
        address
        mailingAddress
        city
        state
        timeZone
        webURL
        contactInfoURL
        linkedinURL
        contactInfoComments
        callingComments
        emailComments
        linkedinComments
        scheduledCallComments
        opsTeamComments
        leadsContacts{
          contactPerson
          title
          phone
          optIn
          email
          remarks
          status
          verifiedAt
          verifyResult
          verifyCode
          verifyReason
          unsubscribedAt
        }
        leadsCalls{
          date
          time
          status
          spokeWith
          callby
          emailSent
          remarks
        }
        leadsEmails{
          id
          date
          time
          status
          emailedto
          emailedy
          remarks
          emailFollowup
          emailFrom
          emailBody
          emailID
          conversationId
          trackId
          deliveryStatus
          openedAt
          deliveredAt
          bounceReason
          replyMessageIds
          replyFrom
          replySubject
          replyReceivedAt
          replyBody
          body
          isDraft
          draftSavedAt
        }
        leadsLinkedins{
          date
          time
          status
          requestTo
          requestBy
          remarks
        }
        leadsScheduledCalls{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          timeZone
          remarks
        }
        leadsOPS{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          remarks
          callConnected
          clientAttendees
          blueplanitAttendees
          amsusedbyClient
          clientRequirements
          pros
          cons
          emailSent
        }

    }
  }
`;

export const GET_LEAD_BY_ID = gql`
  query ($id: String!) {
    getLeadById(id: $id) {
      id
        leadID
        isInPipeline
        pipelineStage
        lostReason
        dealValue
        createdDate
        createdBy
        lastUpdatedDate
        lastContactedDate
        followup
        followupDate
        callscheduledwithOPs
        assign
        assignedTo
        assignTo
        assignedAt
        isAssignLocked
        assignLockedAt
        assignUnlockAt
        priority
        status
        stage
        channel
        successfull
        agencyName
        dba
        address
        mailingAddress
        city
        state
        timeZone
        webURL
        contactInfoURL
        linkedinURL
        contactInfoComments
        callingComments
        emailComments
        linkedinComments
        scheduledCallComments
        opsTeamComments
        leadsContacts{
          contactPerson
          title
          phone
          optIn
          email
          remarks
          status
          verifiedAt
          verifyResult
          verifyCode
          verifyReason
          unsubscribedAt
        }
        leadsCalls{
          date
          time
          status
          spokeWith
          callby
          emailSent
          remarks
          recordingid
          from
          to
          duration
        }
        leadsEmails{
          id
          date
          time
          status
          emailedto
          emailedy
          remarks
          emailFollowup
          emailFrom
          emailBody
          emailID
          conversationId
          trackId
          deliveryStatus
          openedAt
          replyMessageIds
          replyFrom
          replySubject
          replyReceivedAt
          replyBody
          body
          isDraft
          draftSavedAt
        }
        leadsLinkedins{
          date
          time
          status
          requestTo
          requestBy
          remarks
        }
        leadsScheduledCalls{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          timeZone
          remarks
        }
        leadsOPS{
          date
          time
          callType
          emails
          phonenumber
          callScheduledBy
          remarks
          callConnected
          clientAttendees
          blueplanitAttendees
          amsusedbyClient
          clientRequirements
          pros
          cons
          emailSent
        }
    }
  }
`;

export const CREATE_LEAD_FILTER = gql`
  mutation (
    $userID: String!
    $filterName: String!
    $filterString:String!
    $filterStatus:Boolean!
   
    ) {
      createLeadFilters(
        userID: $userID
        filterName: $filterName
        filterString: $filterString
        filterStatus: $filterStatus) {
          id
          userID
          filterName
          filterString
          filterStatus
        }
      }
    `;

export const GET_ALL_LEAD_FILTERS_BY_ID = gql`
    query ($userID: String!) {
      getAllLeadFilterByID(userID: $userID) {
        id
        userID
        filterName
        filterString
        filterStatus
      }
    }
  `;


export const CREATE_LEAD_WORKHISTORY = gql`
  mutation (
    $leadId: String!
    $userName: String!
    $action: String!
    $leadStatus:String!
    $changeTime:String!
    ) {
      createLeadWorkHistory(
        leadId: $leadId
        userName: $userName
        action: $action
        leadStatus: $leadStatus
        changeTime: $changeTime) {
          id
          leadId
          userName
          action
          leadStatus
          changeTime
        }
      }
    `;

export const GET_ALL_LEAD_WORKHISTORY_BY_ID = gql`
    mutation ($leadId: String!) {
      getAllLeadWorkHistoryByID(leadId: $leadId) {
        id
        leadId
        userName
        action
        leadStatus
        changeTime
        actorType
        summary
        changes { field oldValue newValue section kind item }
      }
    }
  `;

export const GET_ALL_LEAD_WORKHISTORY = gql`
    query ($emailId: String!) {
      getAllWorkHistoryByID(emailId: $emailId) {
            id
            userId
            emailId
            email
            subject
            body
            startTime
            endTime
            taskType
      }
    }
  `;

export const CHAT_GPT_MUTATION = gql`
  mutation ChatGPTMutation($prompt: String!) {
    ChatGPTQuery(prompt: $prompt) {
      response {
        content
      }
    }
  }
`;

export const GET_SALES_LEADERBOARD = gql`
  query GetSalesLeaderboard {
    getSalesLeaderboard {
      status
      message
      leaderboard {
        repName
        calls
        emails
        linkedIn
        leadsAssigned
        pipelineDeals
        closedWon
        totalDealValue
      }
    }
  }
`;

export const GET_SALES_STATS = gql`
  query GetSalesStats {
    getSalesStats {
      status
      message
      response {
        todayStats {
          calls
          emails
          linkedIn
          leadsGenerated
          callWithOps
        }
        monthStats {
          calls
          emails
          linkedIn
          leadsGenerated
          callWithOps
        }
        followUpsStats {
          todayFollowUps
          followUpsWithOps
          monthFollowUps
          totalFollowUps
        }
        totalStats {
          totalLeads
          leadsGenerated
          callsScheduledForOps
          leadsConnectedWithOps
          leadsClosed
        }
        last12MonthsStats {
          year
          month
          calls
          emails
          linkedIn
          leadsGenerated
          callWithOps
        }
      }
    }
  }
`;

export const UPDATE_LAST_LEADS_CALL = gql`
  mutation UpdateLastLeadsCall($leadID: String!, $callUpdate: LeadsCallsInput,$lastcalltime: String!) {
    updateLastLeadsCall(leadID: $leadID, callUpdate: $callUpdate,lastcalltime: $lastcalltime) {
      leadID
      leadsCalls {
        date
        time
        status
        spokeWith
        callby
        emailSent
        remarks
        recordingid
        from
        to
        duration
      }
    }
  }
`;

export const BULK_UPDATE_LEADS = gql`
  mutation BulkUpdateLeads(
    $ids: [String]!,
    $status: String,
    $stage: String,
    $priority: String,
    $assignedTo: String,
    $assignTo: String,
    $assign: Boolean,
    $followup: Boolean,
    $followupDate: String,
    $isInPipeline: Boolean,
    $pipelineStage: String,
    $channel: String,
  ) {
    bulkUpdateLeads(
      ids: $ids,
      status: $status,
      stage: $stage,
      priority: $priority,
      assignedTo: $assignedTo,
      assignTo: $assignTo,
      assign: $assign,
      followup: $followup,
      followupDate: $followupDate,
      isInPipeline: $isInPipeline,
      pipelineStage: $pipelineStage,
      channel: $channel,
    ) {
      status
      message
    }
  }
`;

export const GET_DUPLICATE_LEADS = gql`
  query GetDuplicateLeads {
    getDuplicateLeads {
      status
      message
      totalGroups
      groups {
        primaryId
        primaryName
        matches {
          id
          leadID
          agencyName
          city
          state
          webURL
          assignedTo
          status
          stage
          contactCount
          callCount
          emailCount
          matchScore
          matchReason
        }
      }
    }
  }
`;

export const MERGE_LEADS = gql`
  mutation MergeLeads($primaryLeadId: String!, $duplicateLeadId: String!) {
    mergeLeads(primaryLeadId: $primaryLeadId, duplicateLeadId: $duplicateLeadId) {
      status
      message
      mergedLeadId
    }
  }
`;

export const CREATE_EMAIL_SEQUENCE = gql`
  mutation CreateEmailSequence(
    $leadId: String!,
    $leadName: String,
    $sequenceName: String,
    $contactEmail: String!,
    $repName: String,
    $repEmail: String,
    $fromEmail: String,
    $createdBy: String,
    $steps: [SequenceStepInput],
  ) {
    createEmailSequence(
      leadId: $leadId,
      leadName: $leadName,
      sequenceName: $sequenceName,
      contactEmail: $contactEmail,
      repName: $repName,
      repEmail: $repEmail,
      fromEmail: $fromEmail,
      createdBy: $createdBy,
      steps: $steps,
    ) {
      status
      message
      sequence {
        id
        leadId
        leadName
        sequenceName
        status
        pauseReason
        currentStep
        nextRunDate
        contactEmail
        fromEmail
        steps {
          stepNumber
          delayDays
          emailType
          subject
          body
          templateId
          templateName
          status
          sentAt
          trackId
          messageId
        }
      }
    }
  }
`;

export const UPDATE_EMAIL_SEQUENCE_STATUS = gql`
  mutation UpdateEmailSequenceStatus($sequenceId: String!, $status: String!) {
    updateEmailSequenceStatus(sequenceId: $sequenceId, status: $status) {
      status
      message
      sequence {
        id
        status
        pauseReason
        currentStep
        nextRunDate
      }
    }
  }
`;

export const GET_EMAIL_SEQUENCES_BY_LEAD = gql`
  query GetEmailSequencesByLead($leadId: String!) {
    getEmailSequencesByLead(leadId: $leadId) {
      status
      message
      sequences {
        id
        leadId
        leadName
        sequenceName
        status
        pauseReason
        currentStep
        nextRunDate
        contactEmail
        fromEmail
        repName
        createdAt
        steps {
          stepNumber
          delayDays
          emailType
          subject
          body
          templateId
          templateName
          status
          sentAt
          trackId
          messageId
        }
      }
    }
  }
`;

export const GET_PIPELINE_LEADS = gql`
  query GetPipelineLeads {
    getPipelineLeads {
      id
      leadID
      isInPipeline
      pipelineStage
      lostReason
      dealValue
      createdDate
      createdBy
      lastUpdatedDate
      lastContactedDate
      followup
      followupDate
      callscheduledwithOPs
      assign
      assignedTo
      assignTo
      assignedAt
      isAssignLocked
      assignLockedAt
      assignUnlockAt
      priority
      status
      stage
      channel
      successfull
      agencyName
      dba
      address
      mailingAddress
      city
      state
      timeZone
      webURL
      contactInfoURL
      linkedinURL
      contactInfoComments
      callingComments
      emailComments
      linkedinComments
      scheduledCallComments
      opsTeamComments
      leadsContacts {
        contactPerson
        title
        phone
        email
        optIn
        remarks
        status
      }
      leadsCalls {
        date
        time
        status
        spokeWith
        callby
        emailSent
        remarks
      }
      leadsEmails {
        date
        time
        status
        emailedto
        emailedy
        remarks
        emailFollowup
        emailFrom
        emailBody
        emailID
        conversationId
        trackId
        deliveryStatus
        openedAt
        replyMessageIds
        replyFrom
        replySubject
        replyReceivedAt
        replyBody
      }
      leadsLinkedins {
        date
        time
        status
        requestTo
        requestBy
        remarks
      }
      leadsScheduledCalls {
        date
        time
        callType
        emails
        phonenumber
        callScheduledBy
        timeZone
        remarks
      }
      leadsOPS {
        date
        time
        callType
        emails
        phonenumber
        callScheduledBy
        remarks
        callConnected
        clientAttendees
        blueplanitAttendees
        amsusedbyClient
        clientRequirements
        pros
        cons
        emailSent
      }
    }
  }
`;

// Draft email fragment — fields returned after save/discard
const DRAFT_EMAILS_FRAGMENT = `
  leadsEmails {
    id
    emailFrom
    emailedto
    emailedy
    remarks
    emailBody
    body
    isDraft
    draftSavedAt
    deliveryStatus
    date
    time
  }
`;

export const SAVE_DRAFT = gql`
  mutation SaveDraft(
    $leadId:    String!
    $draftId:   String
    $emailFrom: String
    $emailedto: String
    $emailCC:   String
    $emailBCC:  String
    $subject:          String
    $body:             String
    $draftAttachments: String
  ) {
    saveDraft(
      leadId:           $leadId
      draftId:          $draftId
      emailFrom:        $emailFrom
      emailedto:        $emailedto
      emailCC:          $emailCC
      emailBCC:         $emailBCC
      subject:          $subject
      body:             $body
    ) {
      id
      leadsEmails {
        id
        date
        time
        status
        emailedto
        emailedy
        remarks
        emailFollowup
        emailFrom
        emailBody
        emailID
        conversationId
        trackId
        deliveryStatus
        openedAt
        replyMessageIds
        replyFrom
        replySubject
        replyReceivedAt
        replyBody
        body
        isDraft
        draftSavedAt
      }
    }
  }
`;

export const DISCARD_DRAFT = gql`
  mutation DiscardDraft($leadId: String!, $draftId: String!) {
    discardDraft(leadId: $leadId, draftId: $draftId) {
      id
      leadsEmails {
        id
        date
        time
        status
        emailedto
        emailedy
        remarks
        emailFollowup
        emailFrom
        emailBody
        emailID
        conversationId
        trackId
        deliveryStatus
        openedAt
        replyMessageIds
        replyFrom
        replySubject
        replyReceivedAt
        replyBody
        body
        isDraft
        draftSavedAt
      }
    }
  }
`;